<div class="info-container fx-column fx-justify-start fx-items-stretch fx-lt-lg-justify-start fx-lt-lg-items-center" style="width:100%; gap: 10px">
  @if (fields) {
    <ng-container [ngTemplateOutlet]="containerTemplate" [ngTemplateOutletContext]='{fields:fields}'></ng-container>
  }
</div>
<ng-template #containerTemplate let-cfields='fields'>
  @for (item of cfields; track item) {
    @if (item && item.fields) {
      <div [ngClass]='item.config && item.config.class' [ngStyle]="buildFxStyle(item.config)" [style.max-width]='item.config && item.config.maxWidth' class="info-container fx-lt-lg-column fx-lt-lg-justify-start fx-lt-lg-items-center fx-lt-lg-flex-auto" style="width:100%; gap: 10px">
        <ng-container [ngTemplateOutlet]="containerTemplate" [ngTemplateOutletContext]='{fields: item.fields}'></ng-container>
      </div>
    }
    @if (item && !item.fields) {
      <data-field-viewer [fieldDefinition]='item' [record]='record' [dataContainerService]='dataContainerService'></data-field-viewer>
    }
  }
</ng-template>
